import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'

import { formatMoneyInput } from "helpers/helpers"
import { httpOk, GET } from "helpers/api"

function Index({
	users,
	selectedItem,
	setSelectedItem,
	createUpdate,
	modalCreateUpdate,
	toggleModalCreateUpdate
}) {
	const { t } = useTranslation()

	const types = [
		{ 'id': 'brand', 'name': "Бренд" },
		{ 'id': 'branch', 'name': "Филиал" },
	]

	const [countries, setCountries] = useState([])
	const [regions, setRegions] = useState([])
	const [districts, setDistricts] = useState([])
	const [posTypes, setPosTypes] = useState([])

	async function handleSelectCountry(option) {
		setSelectedItem({ ...selectedItem, 'country_id': option ? option.id : null })
		if (option) getRegions(option.id)
	}

	async function handleSelectRegion(option) {
		setSelectedItem({ ...selectedItem, 'region_id': option ? option.id : null })
		if (option) getDistricts(option.id)
	}

	async function handleSelectDistrict(option) {
		setSelectedItem({ ...selectedItem, 'district_id': option ? option.id : null })
	}

	async function getPosTypes() {
		const response = await GET('/admin/helper/pos-types')
		if (httpOk(response)) setPosTypes(response.data)
	}

	async function getCountries() {
		const response = await GET('/helper/countries')
		if (httpOk(response)) setCountries(response.data)
	}

	async function getRegions(country_id) {
		const response = await GET(`/helper/regions/${country_id}`)
		if (httpOk(response)) setRegions(response.data)
	}

	async function getDistricts(region_id) {
		const response = await GET(`/helper/districts/${region_id}`)
		if (httpOk(response)) setDistricts(response.data)
	}

	useEffect(() => {
		getCountries()
		getPosTypes()

		if (selectedItem.id && selectedItem.country_id) getRegions(selectedItem.country_id)
		if (selectedItem.id && selectedItem.region_id) getDistricts(selectedItem.region_id)
	}, [modalCreateUpdate]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL CREATE UPDATE*/}
			<Modal Modal show={modalCreateUpdate} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalCreateUpdate()
				}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<span>{t('create')}</span>
							:
							<span>{t('edit')}</span>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						{!selectedItem.id &&
							<div className="form-group">
								<label>{t('type')}</label>
								<Select
									isDisabled={selectedItem.id}
									options={types}
									value={types.find(option => option.id === selectedItem.type) || ''}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'type': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						}

						{selectedItem.type === 'brand' &&
							<div className="d-flex gap-2">
								<div className="form-group w-100">
									<label>{t('name')}</label>
									<input type="text" className="form-control" name="first_name" value={selectedItem.first_name ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'first_name': e.target.value })} />
								</div>

								<div className="form-group w-100">
									<label>{t('login')}</label>
									<input type="text" className="form-control"
										disabled={selectedItem.id}
										name="login" value={selectedItem.login ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'login': e.target.value.toLowerCase() })} />
								</div>
								<div className="form-group w-100">
									<label>{t('password')}</label>
									<input type="text" className="form-control"
										name="password" value={selectedItem.password ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'password': e.target.value })} />
								</div>
								<div className="form-group w-100">
									<label>{t('phone')}</label>
									<input type="number" className="form-control" name="phone" value={selectedItem.phone ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value })} />
								</div>
							</div>
						}
						{selectedItem.type === 'branch' &&
							<div className="form-group">
								<label>{t('users')}</label>
								<Select
									options={users}
									value={users.find(option => option.login === selectedItem.login) || ''}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'login': option ? option.login : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.login}
									getOptionValue={(option) => option.id}
								/>
							</div>
						}

						<hr />

						<div className="d-flex gap-2 w-100">
							<div className="form-group w-100">
								<label>{t('countries')}<span className="required-mark">*</span></label>
								<Select
									isClearable
									options={countries}
									value={countries.find(option => option.id === selectedItem.country_id) || ''}
									onChange={(option) => handleSelectCountry(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<div className="form-group w-100">
								<label>{t('regions')}</label>
								<Select
									isClearable
									options={regions}
									value={regions.find(option => option.id === selectedItem.region_id) || ''}
									onChange={(option) => handleSelectRegion(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<div className="form-group w-100">
								<label>{t('districts')}</label>
								<Select
									isClearable
									options={districts}
									value={districts.find(option => option.id === selectedItem.district_id) || ''}
									onChange={(option) => handleSelectDistrict(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						</div>

						<hr />

						<div className="d-flex gap-2">
							<div className="form-group">
								<label>{t('name2')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="name" value={selectedItem.name}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
							</div>
							<div className="form-group">
								<label>{t('tin')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="tin" value={selectedItem.tin ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'tin': e.target.value })} />
							</div>
							<div className="form-group">
								<label>{t('tariff')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="tariff"
									value={formatMoneyInput(selectedItem.tariff) ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'tariff': e.target.value.replace(/[^0-9.]/g, '') })} />
							</div>
							<div className="form-group">
								<label>{t('balance')}</label>
								<input type="text" className="form-control" name="balance"
									disabled={selectedItem.id}
									placeholder="0"
									value={formatMoneyInput(selectedItem.balance) ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'balance': e.target.value.replace(/[^-0-9.]/g, '') })} />
							</div>
						</div>
						{/* Склад не пробивает чеки — в «Заботе о клиентах» его не считают неработающим */}
						<div className="form-group">
							<label>Тип точки</label>
							<Select
								options={posTypes}
								value={posTypes.find(option => option.id === (selectedItem.pos_type_id ?? 1)) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'pos_type_id': option ? option.id : 1 })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						{selectedItem.id &&
							<div className="form-group">
								<label>{t('phone')}</label>
								<input type="text" className="form-control" name="phone" placeholder="998901234567"
									inputMode="numeric" maxLength={13}
									value={selectedItem.phone ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value.replace(/\D/g, '') })} />
							</div>
						}
						<div className="d-flex justify-content-between">
							<p className="fw-600 vertical-center">{t('is_vat_payer')}</p>
							<div className="form-check form-switch form-switch-md">
								<input type="checkbox" className="form-check-input" name="is_vat_payer"
									checked={selectedItem?.is_vat_payer ?? false}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'is_vat_payer': e.target.checked })} />
							</div>
						</div>
						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalCreateUpdate()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE UPDATE*/}
		</>
	)
}

export default Index